module.exports = __webpack_public_path__ + "img/服务支持.20f5708e.png";